module.exports = function configure($logProvider) {
  if ($logProvider.debugEnabled) {
    $logProvider.debugEnabled(true);
  }
};

module.exports.$inject = ['$logProvider'];
